export default {
  app: {
    title: 'Franchisee Management System',
    emergencyContactSettingsTitle: 'Emergency Contact Settings',
    emergencyContactTableSerial: 'S/N',
    emergencyContactTableName: 'Name',
    emergencyContactTablePhone: 'Mobile',
    emergencyContactTableDingTalk: 'DingTalk ID',
    emergencyContactWithIndex: 'Emergency contact {n}',
    followUpStudentTitle: 'Student Follow-Up',
    followUpStudentTabAddFollow: 'Add Follow-Up',
    followUpStudentTabCompleteProfile: 'Complete Profile',
    followUpStudentStudentName: 'Student Name',
    followUpStudentCustomerIntent: 'Customer Interest Level',
    followUpStudentFollowStatus: 'Follow-Up Status',
    followUpStudentStudentTags: 'Student Tags',
    followUpStudentCallCommStatus: 'Call Status',
    followUpStudentFollowContent: 'Follow-Up Notes',
    followUpStudentFollowContentTipLine1: 'e.g., follow-up attempt number; explained Squirrel Ai advantages; interested subjects;',
    followUpStudentFollowContentTipLine2: 'parent attitude; whether next follow-up is scheduled, etc.',
    followUpStudentUploadImageHint: 'Supports JPG/PNG, recommended size 1080x1920, max 5MB',
    followUpStudentCredentialSample: 'Sample',
    followUpStudentNextCommTime: 'Next Contact Time',
    followUpStudentSelectDate: 'Select Date',
    followUpStudentSelectTime: 'Select Time',
    followUpStudentPlaceholderSelectIntent: 'Select interest level',
    followUpStudentPlaceholderSelectFollowStatus: 'Select follow-up status',
    followUpStudentPlaceholderFollowContent: 'Enter follow-up notes',
    followUpStudentPhone: 'Phone Number',
    followUpStudentPlaceholderPhone: 'Enter phone number',
    followUpStudentSex: 'Gender',
    followUpStudentMale: 'Male',
    followUpStudentFemale: 'Female',
    followUpStudentBirthday: 'Date of Birth',
    followUpStudentPlaceholderBirthday: 'Select date of birth',
    followUpStudentHomeAddress: 'Home Address',
    followUpStudentPlaceholderHomeAddress: 'Enter home address',
    followUpStudentStudentType: 'Student Type',
    followUpStudentPlaceholderSelectStudentType: 'Select student type',
    followUpStudentStageGrade: 'Grade Level',
    followUpStudentPlaceholderSelectStage: 'Select level',
    followUpStudentPlaceholderSelectGrade: 'Select grade',
    followUpStudentSource: 'Source',
    followUpStudentStudentSchool: 'School',
    followUpStudentPlaceholderSelectSchool: 'Select school',
    followUpStudentCourseAdvisor: 'Course Advisor',
    followUpStudentPlaceholderSelectAdvisor: 'Select advisor',
    followUpStudentRegionOne: 'Region 1',
    followUpStudentRegionTwo: 'Region 2',
    followUpStudentContact1: 'Contact 1',
    followUpStudentPlaceholderContact1: 'Enter contact 1',
    followUpStudentContact2: 'Contact 2',
    followUpStudentPlaceholderContact2: 'Enter contact 2',
    followUpStudentContact3: 'Contact 3',
    followUpStudentPlaceholderContact3: 'Enter contact 3',
    followUpStudentRemark: 'Notes',
    followUpStudentPlaceholderRemark500: 'Up to 500 characters',
    selectProductTitle: 'Select Product',
    confirmDeleteComponent: 'Are you sure you want to delete this component?',
    logisticsDetailsTitle: 'Shipping Details',
    cannotSubscribeTipTitle: 'Subscription Not Available',
    shipmentTitle: 'Shipment',
    assignCoursesTitle: 'Assign Courses',
    batchCancelAssignedCoursesTitle: 'Bulk Unassign Courses',
    editSchoolTitle: 'Edit School',
    addSchoolTitle: 'Add School',
    editInfoTitle: 'Edit Information',
    addInformationTitle: 'Add Information',
    addRelatedOrderTitle: 'Add Related Order',
    verificationPromptTitle: 'Verification',
    addInvoiceTitle: 'Add Invoice',
    addContractTitle: 'Add Contract',
    contractInfo: 'Contract Information',
    multipleSchoolQueryTitle: 'Multi-School Search',
    changeDetailsTitle: 'Change Details',
    subjectChangeWarningTitle: 'Entity Change Alert',
    editAccountTitle: 'Edit Account',
    addAccountTitle: 'Add Account',
    agentInitialAccountAmountTitle: 'Master Franchisee Initial Account Balance',
    cashRechargeTitle: 'Cash Account Recharge',
    switch: 'Switch',
    enable: 'Enable',
    save: 'Save',
    delete: 'Delete',
    warning: 'Warning',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    reset: 'Reset',
    refreshStatus: 'Refresh Status',
    export: 'Export',
    exportDetail: 'Export Details',
    import: 'Import',
    upload: 'Upload',
    download: 'Download',
    done: 'Done',
    prevStep: 'Previous',
    downloadImportTemplate: 'Download Template',
    operation: 'Actions',
    operationSuccess: 'Operation successful',
    detail: 'Detail',
    details: 'Details',
    userDetail: 'User Details',
    submit: 'Submit',
    back: 'Back',
    close: 'Close',
    labelColon: ':',
    loading: 'Loading...',
    pleaseEnter: 'Please enter',
    yuan: '$',
    complete: 'Done',
    success: 'Operation successful',
    saveSuccess: 'Saved successfully',
    uploadSuccess: 'Uploaded successfully',
    uploadFail: 'Upload failed',
    uploadFileSize5MB: 'File size must not exceed 5MB!',
    failed: 'Operation failed',
    modifyFail: 'Update failed',
    loadFail: 'Failed to load',
    claimFail: 'Claim failed',
    inviteFail: 'Invitation failed',
    changeFail: 'Change failed',
    experienceFail: 'Experience failed',
    linkSuccess: 'Linked successfully',
    linkFail: 'Link failed',
    confirmSuccess: 'Confirmed successfully',
    editFail: 'Edit failed',
    orderQueryFail: 'Order query failed',
    createSuccess: 'Created successfully',
    createFail: 'Creation failed',
    addMaterialSuccess: 'Material added successfully',
    modifyMaterialFail: 'Failed to update material',
    addMaterialFail: 'Failed to add material',
    deleteMaterialFail: 'Failed to delete material',
    helpCenter: 'Help Center',
    closeSystem: 'Exit System',
    accountSecurity: 'Account Security',
    exportDownload: 'Export & Download',
    codeSendFailed: 'Failed to send verification code',
    days: 'Days',
    startDate: 'Start Date',
    endDate: 'End Date',
    to: 'to',
    filterPlaceholder: 'Enter search keywords',
    available: 'Available',
    selected: 'Selected',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    retrievePassword: 'Reset Password',
    retrievePasswordTip: 'Use your registered phone number to reset your password',
    codePlaceholder: 'Verification Code',
    send: 'Send',
    countDownResend: 'Resend in {n}s',
    loginDeprecNotice: 'This login entry will be discontinued on October 31, 2024. If your account has not been upgraded, please follow the system instructions after login to bind your phone number and complete the upgrade. For assistance, contact Squirrel Ai Support.',
    newPassword: 'New Password',
    pleaseEnterNewPassword: 'Enter new password',
    serialNo: 'No.',
    tip: 'Notice',
    pleaseSelect: 'Select',
    selectAgentPlaceholder: 'Select Master Franchisee ID/Name',
    searchAgentPlaceholder: 'Search by Master Franchisee ID/Name',
    select: 'Select',
    label: 'Payment Method:',
    amount: 'Recharge Amount:',
    total: 'Total',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    public: 'Public',
    private: 'Private',
    attention: 'Attention',
    goToExportDownload: 'Go to',
    importExport: 'Import & Export',
    goToExportDownloadSuffix: ' to download',
    notNow: 'Not now',
    goToDownload: 'Go to Export & Download',
    changeVerifyPhoneTitle: 'Change Verification Phone - Identity Verification',
    changePhoneBindTitle: 'Change Phone Number - Bind New Number',
    copySuccess: 'Copied successfully',
    more: 'More',
    view: 'View',
    copy: 'Copy',
    disabled: 'Disabled',
    primaryTag: 'Primary',
    planningDept: 'Planning Department',
    classHours: 'Class Hours',
    classHoursWithNum: '{n} class hours',
    unbound: 'Unbound',
    bindPhoneTip: 'After linking your phone number, you can use it to log in and recover your password',
    pinTop: 'Pin to Top',
    viewDetail: 'View Details',
    noPermissionContactAdmin: 'No permission. Please contact the administrator.',
    noPermissionContactAgentAdmin: 'No permission. Please contact your Master Franchisee admin.',
    noPermissionRestrictedPrefix: 'Your system access has been restricted. Reason:',
    noPermissionContactCustomerService: 'Please contact support',
    queryBalanceFailed: 'Failed to query balance',
    accountCreateTip: 'After account creation, the status will be "Pending Confirmation" and cannot be used to log in. The user will receive a DingTalk invitation from headquarters. After accepting the invitation, the account status will change to "Active" and login will be enabled.',
    continue: 'Continue',
    accountUpgrade: 'Account Upgrade',
    accountUpgraded: 'Account Upgraded',
    accountUpgradeIntro: 'Upgrade your Master Franchisee account in just one minute to a',
    squirrelAiAccount: 'Squirrel Ai Account',
    upgradeBenefits: 'After upgrading, you will receive the following benefits:',
    unifiedAccount: 'Unified Account',
    unifiedAccountDesc: 'Manage all your Master Franchisee and analyst accounts with a single phone number',
    security: 'Security & Privacy',
    securityDesc: 'Enhance account security by linking your phone number and DingTalk',
    joinTraining: 'Access Training',
    joinTrainingDesc: 'Join the Squirrel Ai DingTalk organization to access training materials and stay updated on new features',
    upgradeNow: 'Upgrade Now',
    bindPhone: 'Link Phone Number',
    bindPhoneDesc: 'We will use your phone number to create or link your Squirrel Ai account',
    phoneForRecovery: 'Enter phone number (used for account recovery)',
    scanToActivate: 'Scan to activate your account',
    goToDingTalk: 'Go to DingTalk to Complete Upgrade',
    mergeAccount: 'Merge Accounts',
    mergeAccountDesc: 'If you have other Master Franchisee accounts to merge, please add them below',
    accountList: 'Account List',
    addAccount: '+ Add Account',
    refresh: 'Refresh',
    contactService: 'If you encounter any issues, please contact Squirrel Ai Support',
    setFilterFirst: 'Please set filter criteria first',
    bindMobile: 'Link Phone',
    modifyPassword: 'Change Password',
    salesCenter: 'Sales Center',
    serviceCenter: 'Service Center',
    financeCenter: 'Finance Center',
    businessManagement: 'Business Management',
    innovationBusiness: 'Innovation Business',
    deliveryManagement: 'Shipping Management',
    agentServiceProvider: 'Master Franchisee Service Provider',
    headquartersTools: 'Headquarters Tools',
    configBackend: 'System Configuration',
    statisticalAnalysis: 'Analytics',
    warehouseManagement: 'Warehouse Management',
    agentManagement: 'Master Franchisee Management',
    resourceLibrary: 'Resource Library',
    referralHelpCenter: 'Referral Help Center',
    referralPerformanceQuery: 'For referral performance rules and queries, please refer to the Help Center;',
    referralCustomerInRegionQuery: 'For regional referral customer queries, please refer to the Help Center;',
    referralCustomerFirstContract: 'For rules and queries on first contract rewards, please refer to the Help Center;',
    referralCustomerInRegion: 'Referral Customer Region',
    channelRebateService: 'For channel rebate and service fee rules, please refer to the Help Center;',
    storageFeeExemptionNotice: 'Storage Fee Waiver Notice',
    callLineBusy: 'Call line busy',
    outboundLineBusy: 'Outbound line busy',
    notMigrated: 'Not migrated',
    hardPhone: 'Desk Phone',
    timeDifferenceIs: 'Time difference:',
    downloadCertTemplate: 'Download Certificate Template',
    dealerMiniProgram: 'Franchisee Mini Program',
    headquartersNotice: 'Headquarters Notice',
    agent: 'Master Franchisee',
    dealer: 'Franchisee',
    analyst: 'Analyst',
    analystAccount: 'Analyst Account',
    mainAccount: 'Primary Account',
    subAccount: 'Sub Account',
    mobile: 'Phone Number',
    myWorkOrder: 'My Work Orders',
    myCustomerService: 'My Support',
    noCustomerFound: 'No customers found',
    noDeviceFound: 'No devices found',
    openEntryAccount: 'Create Entry-Level Account',
    learningMachine: 'Learning Tablet',
    creditOrders: 'Credit Orders',
    rechargeFlow: 'Recharge Process',
    bigStudyRoom: 'Study Hall',
    texttnry: 'Shipping Plan',
    targetReminder: 'Target Setting Reminder',
    remindLater: 'Remind me later',
    goToSet: 'Go to Settings',
    newNotice: 'You have a new announcement',
    viewLater: 'View later',
    viewNow: 'View now',
    important: 'Important',
    emergency: 'Urgent',
    callinTip: 'Incoming lead call. Please respond promptly!',
    leadName: 'Lead Name',
    leadPhone: 'Lead Phone Number',
    followStatus: 'Follow-Up Status',
    calloutNotOpen: 'Outbound calling not enabled',
    calloutNotOpenTip: 'Dear Franchisee, your outbound calling service is not activated. Please click "Activate" to enable or renew the service.',
    thinkAgain: 'Maybe later',
    goToOpen: 'Activate now',
    goToRecharge: 'Recharge now',
    calloutOverdue: 'Outbound calling overdue',
    calloutOverdueTip: 'Dear Franchisee, your outbound calling balance has been exceeded. Please click "Recharge" to continue using the service.',
    calloutBusy: 'Outbound lines are busy',
    iKnow: 'Got it',
    gotIt: 'Got it',
    calloutBusyTip: 'All outbound lines are busy. Estimated availability in XX minutes.',
    callTips: 'Tips',
    callTipsContent: 'For better call quality, we recommend using a headset with a microphone connected to your computer.',
    noMoreRemind: 'Got it, do not remind again',
    continueCallout: 'Continue calling',
    ddModalJoinHqTitle: 'Join Squirrel Ai Headquarters',
    ddModalJoinHqSubtitle: 'Learn operations quickly and access best practices',
    ddModalBulletIndustry: 'Understand the industry',
    ddModalBulletSystem: 'Learn how to use the system',
    ddModalBulletSales: 'Improve your sales and service skills',
    ddModalScanToJoin: 'Scan with DingTalk to join',
    ddModalTrainUnlockTitle: 'Unlock after completing DingTalk training',
    ddModalMobileLearn: 'Scan with DingTalk on mobile to learn',
    ddModalDesktopLearn: 'Access training via DingTalk on desktop',
    ddModalSignupFailed: 'Registration failed. Please try again later.',
    trainingBannerCountdownPrefix: 'Training countdown ',
    trainingBannerUrgentSuffix: ' days remaining. If not completed on time, access will be locked',
    trainingBannerGoTrain: 'Go to Training',
    headerPersonalCenter: 'Profile',
    editorPlacementAreaLabel: 'Component Placement Area',
    notFoundTitle: 'Page Not Found',
    notFoundTip: 'The page you are looking for does not exist or has been removed',
    notFoundBackHome: 'Back to Home',
    passwordResetSuccess: 'Password updated successfully. Please log in with your new password',
    passwordResetFail: 'Password update failed',
    verifyFail: 'Verification failed',
    editAccountSuccess: 'Account updated successfully',
    editAccountFail: 'Failed to update account',
    creditOrderPayTip: 'Credit Order Payment Requirements',
    creditOrderPayDesc: 'After the Franchisee completes sales and receives payment, the remaining balance of the credit order must be paid.',
    exemptTip: 'From the date the voucher is received,',
    exemptTip2: ' days will be considered the exemption period. During this period, no storage fee will be charged. For details, please refer to:',
    exemptTip3: 'Based on the above rules, as of yesterday, you have',
    exemptTip4: '$ worth of vouchers approaching the end of the exemption period. Please complete payment promptly. Storage fees will apply to overdue vouchers.',
    doubleOrderTip: 'A dual order allows the provincial Master Franchisee to consolidate purchases for Franchisees using account funds. For details, please refer to:',
    agentAccountTip: 'Master Franchisee Account FAQs',
    subscriptionTip: 'Subscription Plan Definitions & Inquiry',
    referralChannel: 'Referral & Channel Program',
    guinnessTitle: 'Guinness Certificate Application Notice:',
    guinnessP1: 'The application deadline for digital certificates is',
    guinnessP2: '. Please apply before the deadline. Physical certificates are no longer available.',
    guinnessP3: 'The student name and English name will appear on the certificate. Please ensure accuracy.',
    guinnessP4: 'If you wish to',
    guinnessP5: 'update the student name',
    guinnessP6: ', please update it in the Parent App under "Learning Report". For English names, update on this page.',
    guinnessP7: 'Digital certificates are free. Physical certificates were priced at ¥300. Squirrel Ai does not charge any additional fees.',
    guinnessP8: 'Digital certificates are available for download after application. Physical certificates require longer processing time.',
    studentNameCertNotice: 'Student name and English name will be used on the certificate. Please verify carefully.',
    modifyStudentName: 'Edit Student Name',
    guinnessDigitalCertFree: 'Digital certificates are free. Physical certificates were priced at $300. No additional fees are charged by Squirrel Ai.',
    guinnessCertDownloadWait: 'Digital certificates can be downloaded immediately. Physical certificates require longer processing time.',
    startCallout: 'Start Calling',
    endCallout: 'End Calling',
    calloutOnlineSuccess: 'Outbound calling activated successfully',
    calloutOfflineSuccess: 'Outbound calling deactivated successfully',
    micPermissionFail: 'Microphone access denied. Please check your browser settings',
    getCustomerFail: 'Failed to retrieve customer information',
    pleaseStartCallout: 'Please click "Start Calling" at the top right to begin',
    serviceError: 'Service error',
    exportTaskSubmitted: 'Export task submitted successfully',
    pleaseProvideApiUrl: 'Please provide the API endpoint',
    exportFailed: 'Export failed',
    systemError: 'System error. Please contact the administrator',
    confirmRemoveFile: 'Are you sure you want to remove {name}?',
    uploadImage: 'Upload Image',
    cancelUpload: 'Cancel Upload',
    clickUpload: 'Click to Upload',
    within100Chars: 'Up to 100 characters',
    cancelUploadConfirm: 'If you cancel, all entered information will be lost. Continue?',
    uploadImageFail: 'Image upload failed. Please delete and re-upload',
    pleaseUploadImage: 'Please upload an image',
    selectCommodity: 'Select Product',
    pleaseSelectJumpType: 'Select jump type',
    pleaseSelectImageLink: 'Select image link',
    pleaseEnterLink: 'Enter a valid URL',
    pleaseSelectUser: 'Select user',
    pleaseEnterKeywordFilter: 'Enter keyword',
    pleaseSelectProductType: 'Select product type',
    pleaseSelectCounter: 'Select counter',
    pleaseSelectProvinceCity: 'Select city/state',
    pleaseSelectProvinceCityDistrict: 'Select city/state',
    pleaseSelectFault: 'Select issue category',
    pleaseSelectAgentRegion: 'Select Master Franchisee region',
    startDatePlaceholder: 'Start Date',
    endDatePlaceholder: 'End Date',
    clearFilter: 'Clear Filters',
    collapse: 'Collapse',
    expand: 'Expand',
    query: 'Search',
    clear: 'Clear',
    pleaseFillRequired: 'Please complete all required fields',
    invoiceQtyDecimalQ: 'Q: Why is the invoice quantity a decimal?',
    invoiceQtyDecimalA: 'A: The withdrawal amount comes from payments made by Franchisees that have already been invoiced by Squirrel Ai. When these funds are withdrawn, corresponding invoice adjustments (such as credit memos or reissued invoices) must be made based on the original orders, including product model, unit price, and total amount. Since the withdrawal amount may be allocated across multiple original orders, each with fixed unit prices, the resulting invoice quantities may appear as decimals.',
    socketConnectFailRetry: 'Unable to connect to the messaging system. Please check your network and try again',
    socketConnectFailClose: 'Unable to connect to the messaging system. Please restart the system',
    transferSuccess: 'Transferred successfully',
    transferFail: 'Transfer failed',
    noPermissionAskSuperior: 'No permission. Please contact your supervisor',
    pleaseSelectAdPosition: 'Select Ad Placement',
    pleaseEnterAdName: 'Enter Ad Name',
    pleaseEnterSort: 'Enter Display Order',
    pleaseSelectStatus: 'Select Status',
    pleaseSelectDisplayScope: 'Select Display Scope',
    publishSuccess: 'Published successfully',
    pleaseEnterContactName: 'Enter Contact Name',
    pleaseEnterCorrectPhoneNum: 'Enter a valid phone number',
    phoneInvalidDigits: 'Please enter valid digits',
    phoneLengthExceed: 'Phone number cannot exceed 20 digits',
    passwordSafetyTip: 'For account security, please update your password regularly',
    oldPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    pleaseEnterOldPassword: 'Enter Current Password',
    pleaseEnterNewPassword: 'Enter New Password',
    pleaseConfirmNewPassword: 'Confirm New Password',
    pleaseEnterNewPasswordAgain: 'Re-enter New Password',
    passwordMismatch: 'Passwords do not match',
    pleaseReenterNewPassword: 'Please re-enter your new password',
    cancel: 'Cancel',
    confirm: 'Confirm',
    newNotice: 'You have a new announcement',
    viewNoticeDetail: 'View announcement details',
    tip: 'Notice',
    confirmDelete: 'Are you sure you want to delete?',
    confirmClose: 'Are you sure you want to close?',
    confirmReturnFreight: 'Are you sure you want to refund shipping?',
    returnFreightSuccess: 'Shipping refunded successfully',
    returnFreightFail: 'Failed to refund shipping',
    returnGoodsTip: 'After returning the shipment, the device SN will be restored and shipping information will be deleted. Please proceed with caution.',
    returnGoodsSuccess: 'Return completed successfully',
    codeSentSuccess: 'Verification code sent successfully',
    passwordResetSuccess: 'Password reset successfully. Please log in with your new password',
    passwordResetFail: 'Password reset failed',
    login: 'Log In',
    passwordLogin: 'Password Login',
    phoneLogin: 'Verification Code Login',
    usernamePlaceholder: 'Enter username or phone number',
    passwordPlaceholder: 'Enter password',
    phone: 'Phone Number',
    password: 'Password',
    rememberMe: 'Remember Me',
    forgotPassword: 'Forgot Password?',
    loginSuccess: 'Login successful',
    verifySuccess: 'Verification successful',
    pleaseEnterPhone: 'Please enter phone number',
    pleaseEnterPassword: 'Please enter password',
    pleaseEnterVerifyCode: 'Please enter verification code',
    pleaseEnterOriginalPhone: 'Please enter original phone number',
    pleaseEnterNewPhone: 'Please enter new phone number',
    invalidPhone: 'Please enter a valid phone number',
    bindSuccess: 'Linked successfully',
    upgradeSuccess: 'Your account has been upgraded to a Squirrel Ai Account. Please log in via the unified platform',
    permissionError: 'Access denied. Please contact support',
    codeSentTip: 'Verification code sent. Please check your phone',
    popupWillCloseIn: 'This window will close in',
    secondsAutoClose: 'seconds',
    auto_1_33bb0b88: 'AI Data Analytics System',
    unsupervisedStudentDataTip: 'For students without Instructor support, please refer to the AI Data Analytics System',
    auto_1_4419517d: '123 Main St, Los Angeles, CA 90012, United States',
    auto_11_3c1407e3: 'This payment will deduct',
    auto_12_21efd9b0: 'Are you sure you want to cancel this order? If cancelled, all payments will be refunded',
    auto_14_7788d61a: 'Call rate per minute',
    auto_15_6c5f790c: 'Service Agreement',
    auto_17_8032e637: 'Pay',
    auto_18_68eb91fb: 'Original Price',
    auto_19_6aed0f56: 'Unlimited users included',
    auto_20_a2a536d4: 'Auto-renews upon expiration',
    auto_26_f93ba179: 'Flexible usage',
    auto_35_056836b2: 'Flexible usage with refund support',
    auto_39_29fb07b1: 'Select a layout area and add images below',
    auto_52_cd58f41b: 'Please enter subscription duration first',
    auto_53_9153b4fc: 'Please read and accept the outbound calling agreement',
    auto_54_21ddab8a: 'Please enter a valid call balance amount',
    auto_58_aaa2e80b: 'Purchase successful',
    auto_60_6c08e91d: 'Next',
    auto_62_b7fb536e: 'My Work Orders',
    auto_62_efa11156: 'Verification successful',
    auto_63_9c495a0c: 'A work order will be submitted to a technical specialist for processing',
    auto_63_c72e441b: 'Change phone number and bind a new one',
    auto_65_5b3129b0: 'Invalid verification code',
    auto_66_3d5ad168: 'Phone verification',
    auto_66_4c74e75e: 'Closed Work Orders',
    auto_67_99c2c990: 'Closed work orders have been resolved. Please view details for responses',
    auto_68_3c08da52: 'Confirm',
    auto_68_419e05d6: 'New Update',
    auto_69_31ad8c59: 'All your work orders are being processed. Please wait for the technical specialist response',
    auto_69_b96f9f4f: 'Login failed',
    auto_70_1ee3a0b3: 'In-Progress Work Orders',
    auto_70_9ca27d68: 'Supporting Documents',
    auto_71_44fb8798: 'Close',
    auto_71_6d2b1005: 'Your work order has been submitted. Please wait for the technical specialist response',
    auto_72_794828ac: 'All your work orders have been completed. Please check Closed Work Orders for details',
    auto_73_0771c815: 'Submit for Review',
    auto_73_32adfc8d: 'Work Order Details',
    auto_74_f6fd4c00: 'Work Order Information',
    auto_75_38ddfcc9: 'Enter student account',
    auto_75_95cc1a8c: 'Work Order ID',
    auto_76_40dca735: 'Work Order Title',
    auto_76_e734dd37: 'Description length (characters)',
    auto_77_39620e02: 'Created By',
    auto_78_0d0b0047: 'Created Time',
    auto_78_2d6f0fc5: 'Please upload supporting documents',
    auto_79_94495c94: 'Select review result',
    auto_79_bd9cd84d: 'Work Order Status',
    auto_80_0cf9382a: 'Handled By',
    auto_80_661f2449: 'Enter review comments',
    auto_81_36b9a3ac: 'Cross-entity Instructor request review',
    auto_81_3ac0816a: 'Completion Time',
    auto_82_403c2cbf: 'Resolution',
    auto_83_2933c8fe: 'Your issue is being processed with priority. Please wait',
    auto_84_44eecdea: 'Cross-entity Instructor request',
    auto_85_7d350f62: 'Student account verification failed',
    auto_86_492ffaa8: 'Failed to verify student account. Please try again later',
    auto_86_5646605a: 'Width',
    auto_87_4591b39a: 'Only image files are allowed',
    auto_88_6d73238a: 'File size must not exceed the limit',
    auto_89_7953c2d5: 'File uploaded successfully',
    auto_90_33e94845: 'File upload failed',
    auto_91_2869b272: 'Review Rejected',
    auto_94_15733a82: 'Pre-check failed before submission',
    auto_95_294563f7: 'This request has already been reviewed. No resubmission needed',
    auto_99_d0373366: 'The current status does not allow submission',
    auto_100_b3dad3de: 'Submitted successfully',
    auto_101_1a13328b: '',
    auto_102_d12681fa: 'Submission failed',
    auto_103_3a39ddcd: 'Submission failed. Please try again later',
    auto_104_4c4e4b6f: 'Spacer',
    auto_105_9be7183a: 'Please add an image',
    auto_106_6d719469: 'No margin',
    auto_106_ec081e14: 'Click to replace image',
    auto_107_f5a8f75f: 'Quota for this period',
    auto_108_8e48f7fd: 'Solid line',
    auto_108_e84a4be3: 'Limit',
    auto_109_cfe7889d: 'Dashed line',
    auto_110_20b0a497: 'Supports JPG, PNG, GIF formats (RGB mode, size limit applies)',
    auto_110_b7b7726f: 'Dotted line',
    auto_111_80630d3f: 'Display',
    auto_115_b9db9487: 'Standard mode',
    auto_118_b48a6ff1: 'Phone Number',
    auto_119_0f491a54: 'Address',
    auto_119_c860d08a: 'Square',
    auto_120_483ae5a2: 'Click to upload QR code',
    auto_121_95bbd0e8: 'Scan to follow the official account',
    auto_123_1131d0ec: 'Drag to reorder products',
    auto_123_7bc0c4f1: 'Align left',
    auto_125_206113c3: 'Click to add product',
    auto_126_ef406980: 'Add product group',
    auto_127_3a945992: 'Drag to reorder groups',
    auto_129_abc25f15: 'Replace image',
    auto_130_fdb36e36: 'Clear image',
    auto_131_32b40046: 'Image Ad',
    auto_132_858e59ff: 'Drag selected navigation items to reorder',
    auto_133_05ace53e: 'Default color',
    auto_134_f4585f3e: 'Click to add image',
    auto_135_c0e8816b: 'Replace',
    auto_135_ebe23c00: 'Style 3',
    auto_137_36c54da9: 'Internal link',
    auto_138_afe8814b: 'External link',
    auto_139_fe1e30e4: 'Image navigation',
    auto_141_6c3240d9: 'Fixed',
    auto_147_83c3e7b8: 'Purchase Amount',
    auto_148_b7220f0c: 'Amount Paid',
    auto_149_4e1fcefb: 'Shipping Option 2: Prepaid',
    auto_151_e6478584: 'Borderless white background',
    auto_152_7819c2cf: 'Card shadow',
    auto_153_6dc7a4dc: 'Outlined white background',
    auto_154_b90eeb18: 'Borderless transparent background',
    auto_155_d4ce2cfe: 'Large image mode',
    auto_156_83ec52fd: 'Two per row',
    auto_157_258d6836: 'Three per row',
    auto_158_15475824: 'Detailed list',
    auto_159_f61a0ab5: 'One large, two small',
    auto_160_33d8ef3f: 'Horizontal scroll',
    auto_161_e28f6ced: 'New',
    auto_163_4adbf233: 'Bottom right',
    auto_167_ef6a4dce: 'Group',
    auto_174_756428f4: 'Two per row',
    auto_176_448098ad: 'Four per row',
    auto_177_0ec2a2f9: 'Two left, two right',
    auto_178_8172d6c2: 'One left, two right',
    auto_179_07abf4f5: 'One top, two bottom',
    auto_179_71c7a446: 'Shipping',
    auto_180_6d92ed35: 'One left, three right',
    auto_183_bd0c8844: 'Supports JPG and PNG formats. Recommended size:',
    auto_184_b68fb5c2: 'Sample',
    auto_185_1f46ba2d: 'Pay',
    auto_187_8434ac96: 'Scan with WeChat',
    auto_190_4bfb417c: 'One per row',
    auto_191_ff1cbeb7: 'Carousel banner',
    auto_192_0bca3c45: 'Invalid QR code URL',
    auto_192_cbb3d8a7: 'Multiple images in one row',
    auto_193_4fec09ce: 'Corporate Transfer',
    auto_193_69fe8e0b: '3D carousel',
    auto_194_a5ebb961: 'Recharge now',
    auto_196_a5c0c783: 'Horizontal navigation scroll',
    auto_198_001d1ca7: 'Recharge successful',
    auto_215_67625bb7: 'Style 4',
    auto_216_388b91ad: 'Background image',
    auto_216_cbf8c407: 'Style 5',
    auto_217_257b91c3: 'Recommended size',
    auto_217_e38e454c: 'Top',
    auto_218_9a3067d4: 'Bottom',
    auto_219_73f2d631: 'Store avatar',
    auto_228_0a0ca324: 'Payment method',
    auto_241_f85bb3b7: 'Subordinate Master Franchisee',
    auto_244_9d956674: 'Select Master Franchisee',
    auto_246_d56d107e: 'Displays note title (max length applies)',
    auto_249_2bd9ac7e: 'To transfer and serve this type of student, approval is required from the provincial Master Franchisee',
    auto_251_45cf4f1a: 'Please upload proof of Instructor service purchase and communication records with parents',
    auto_252_0fa164da: 'Click to upload image',
    auto_253_2d63a546: 'Selected state',
    auto_253_9223791a: 'Dynamic QR codes are used to promote personal WeChat accounts or groups for both online and offline traffic acquisition',
    auto_257_7db1b71e: 'Books',
    auto_258_6c743df7: 'Click to add navigation',
    auto_258_d996f1e4: 'Others',
    auto_259_fb3017dd: 'Searching...',
    auto_260_c50c825c: 'Test',
    auto_262_2a868194: 'Dots',
    auto_262_a7b4945a: 'No data available',
    auto_263_1e2ac1cf: 'If you cancel, all entered information will be lost',
    auto_263_27550dc5: 'Maximum allowed',
    auto_264_fc834024: 'Not configured',
    auto_265_2be97a89: 'Not set',
    auto_265_edec6409: 'To ensure you do not miss urgent and important notifications from headquarters (such as core policies), the system recommends that you set up to 2 emergency contacts for your organization to receive such notifications and communicate them within your team.',
    auto_267_825914e3: 'Select staff',
    auto_268_670ff28c: 'If no emergency contact is needed, click the button on the right to disable this reminder',
    auto_269_def5443e: 'Get verification code',
    auto_270_57fefe83: 'Resend verification code',
    auto_273_0e2e46fd: 'Example: Follow-up attempt number, key points explained about Squirrel Ai, and the student’s subject interest',
    auto_273_aeb07a52: 'Failed to retrieve emergency contact list',
    auto_277_6784f2d4: 'If a student has multiple Instructors, removing one will not affect their status',
    auto_277_db75769c: 'Emergency Contact',
    auto_280_267d7726: 'active students',
    auto_285_c5128c5f: 'Submitted successfully',
    auto_293_be89a148: 'Linked Master Franchisee account balance',
    auto_295_6e62aa26: 'Please select a payment method below',
    auto_296_8f6d4c1d: 'Charge item',
    auto_297_8abf3e2d: 'Unit price',
    auto_298_2da831cc: 'Quantity',
    auto_299_39663d85: 'Drag to reorder keywords. The first keyword will be shown by default in the search bar',
    auto_299_d9edcab4: 'Amount',
    auto_300_6fd6255e: 'Discount',
    auto_301_1c75938c: 'Discounted amount',
    auto_301_c2563ff7: 'Click to add keyword',
    auto_302_6d7b34a0: 'Page settings',
    auto_302_f5bb943f: 'Insurance fee',
    auto_303_c3435521: 'Please avoid frequent actions',
    auto_304_52a4dfe7: 'Shipped successfully',
    auto_305_1d5f092c: 'Drag to reorder cards',
    auto_305_69f78632: 'Shipment failed',
    auto_306_24dad104: 'Payment failed',
    auto_307_c7ba6fe0: 'Click to add card',
    auto_308_09f5aa98: 'Los Angeles, CA 90012, United States',
    auto_318_bdf9a706: 'Payment successful',
    auto_320_2f13c686: 'The bottom navigation is fixed and does not support repositioning',
    auto_322_d314fa61: 'For dropdown options, separate values with symbols (e.g., Male/Female)',
    auto_323_85f1a958: 'Click to add content',
    auto_324_45261ca8: 'Change verification phone number',
    auto_332_a808c5c0: 'Export report',
    auto_335_f142092c: 'Export',
    auto_336_6ffb1d8c: 'WeChat Pay',
    auto_336_898d3792: 'Download import template',
    auto_340_0c616071: 'Upload official account image',
    auto_342_c9f03726: 'Effective from the day after the Instructor service end date',
    auto_343_12743d28: 'Your Squirrel Ai account has been frozen due to inactivity and potential security risks. To continue using the system, please reactivate your account.',
    wakeDialogDeferLogin: 'Not now',
    wakeDialogWakeNow: 'Reactivate now',
    wakeDialogDeferHandle: 'Remind me later',
    wakeDialogConfirmed: 'Confirmed',
    wakeDialogSecondMessage: 'Your Squirrel Ai account under ID {campusId} is being reactivated. Please open DingTalk using the phone number {phone} and accept the team invitation to join the headquarters.',
    auto_343_1d32944f: 'Confirm',
    auto_344_1fc6be2a: 'This account has been inactive for a long time. For security purposes, please save the QR code below and share it with the parent',
    auto_344_b8289acd: 'Select Instructor service end date',
    auto_345_b57279bb: 'Select Learning Center',
    auto_345_e6900270: 'Confirm Publish',
    auto_346_8759d587: 'Name',
    auto_347_221bceee: 'Grade Level',
    auto_348_7338083d: 'Learning Center Account',
    auto_349_d9ef97f6: 'Instructor',
    auto_350_a8adb4c9: 'months',
    auto_354_fd84dda6: 'Pre-K',
    auto_355_b4384eb6: 'Elementary School',
    auto_356_170c6c31: 'Middle School',
    auto_357_9e7d394b: 'High School',
    auto_358_de3dbeff: 'K3',
    auto_359_e011300b: 'K4',
    auto_360_cd722ca1: 'K5',
    auto_361_694fc5e7: 'Grade 1',
    auto_362_4df5bd40: 'Grade 2',
    auto_363_7373adfb: 'Grade 3',
    auto_364_59a9aa58: 'Grade 4',
    auto_365_01ad86b3: 'Grade 5',
    auto_366_8ce6b148: 'Grade 6',
    auto_368_0431dfa1: 'Grade 7',
    auto_369_d05aef19: 'Grade 8',
    auto_370_dc32dacc: 'Grade 9',
    auto_371_391d9d87: 'Grade 10',
    auto_372_b7098df1: 'Grade 11',
    auto_373_1888db71: 'Grade 12',
    auto_374_259e9142: 'Others',
    auto_375_1177b2b7: 'Save failed',
    auto_384_0c33fbe1: 'Customer account organization',
    auto_385_64f70ee4: 'Customer account organization type',
    auto_386_bc3579ad: 'Customer account level',
    auto_387_5f606fef: 'All customer account organizations',
    auto_389_c72ec969: 'Completed',
    auto_398_5ad9a814: 'Confirm removal of trial student',
    auto_403_94fa966b: 'Current Instructor',
    auto_404_83e062bf: 'Current Status',
    auto_452_bddb8735: 'Please enter a valid number',
    auto_559_0e34e723: 'Delete image',
    auto_560_ba0ce9b2: 'Replace image',
    auto_569_4ddb639b: 'Our staff will contact you within a few days',
    auto_570_6c22cb12: 'Select activity start and end time',
    auto_571_717a46b6: 'Activity description image',
    auto_572_45c0748d: 'Activity rules image',
    auto_573_b11b7ea1: 'Organization introduction image',
    auto_575_08a98c36: 'QR code image',
    auto_576_be030eaf: 'Cancel',
    auto_623_77451e5c: 'Closed Won',
    auto_629_0678b836: 'Initiate Call',
    auto_630_10a00a86: 'Connected to Agent',
    auto_631_c32f7c23: 'Agent Ringing',
    auto_632_c3c6c0b6: 'Connecting',
    auto_633_3d13bc80: 'Call Ended',
    auto_634_f6020e93: 'Agent Available',
    auto_635_820490f6: 'Dialing',
    auto_636_10cc60c3: 'Playing Agent ID',
    auto_637_4718bdad: 'Agent Answered',
    auto_638_f7a633c5: 'In Call',
    auto_639_4e4da016: 'This field is required',
    auto_640_2494517e: 'Select All',
    auto_641_5b463606: 'Text',
    auto_649_5399102b: 'Disabled',
    auto_658_966426c5: 'Verification failed',
    auto_676_c665a636: 'Includes Q1 performance',
    auto_677_2371f4ab: 'Includes Q1–Q2 performance',
    auto_678_3edc269e: 'Includes Q1–Q3 performance',
    auto_682_2a8ac5dc: 'Image upload failed. Please delete and try again',
    auto_683_79283b19: 'Only supported file formats are allowed',
    auto_684_28a14bbf: 'Please upload an image',
    auto_685_93ba3225: 'Please re-upload',
    auto_686_67ae8165: 'Continue Learning',
    auto_688_d90ce707: 'Request failed',
    auto_690_faf9e4bc: 'Bottom Navigation',
    auto_691_87642a19: 'Your account has been disabled. Please contact support',
    auto_693_bd7f79f4: 'Reactivated successfully',
    auto_694_777ce4cd: 'Reactivation failed. Please try again later',
    auto_697_23f1290c: 'Image failed to load',
    auto_698_780dddcd: 'Cloud warehouse product inventory',
    auto_699_a53fe93d: 'Cloud warehouse inventory overview',
    auto_704_ff0bd18a: 'Custom course product',
    auto_705_0210c642: 'Product Name',
    auto_706_b21df977: 'Recharge revenue',
    auto_711_23695f4b: 'Procurement Center',
    auto_712_ea6f60e7: 'Restriction reason',
    auto_1733_2683badf: 'To ensure uninterrupted outbound calling, your plan will automatically renew based on the selected subscription duration',
    auto_13_c84c9c0a: 'Funds will be returned to the corresponding Master Franchisee account and the credit order quota will be adjusted',
    auto_22_19c4a75b: 'Can be turned off anytime',
    auto_27_d1819be1: 'Refund supported',
    auto_74_4a659629: 'Submit Application',
    auto_100_675c965a: 'or equivalent ratio',
    auto_101_34344d00: 'Application submitted successfully',
    auto_105_591eb1d9: 'Guideline',
    auto_107_cd7d6781: 'Horizontal padding',
    auto_112_62e20aa3: 'Hidden',
    auto_116_b284796a: 'Sticky on scroll',
    auto_120_46ee5cef: 'Circle',
    auto_122_151d2f40: 'Other Settings',
    auto_124_87dc5816: 'Center',
    auto_136_2294e589: 'Add',
    auto_140_0eebdadc: 'Text Navigation',
    auto_142_94863036: 'Scroll',
    auto_162_c3fd44e9: 'Best Seller',
    auto_254_7d9cf14b: 'Used for adding contacts or fan groups for long-term engagement',
    auto_254_7de05314: 'Unselected state',
    auto_274_f55c1464: 'Parent attitude, follow-up scheduling, etc.',
    auto_294_7ef954c4: 'Account Balance',
    auto_319_e0bf7ef9: 'Payment failed',
    auto_390_9c90503b: 'In Progress',
    auto_399_0204a557: 'Confirm removal of student',
    auto_642_6743fcff: 'Dropdown',
    auto_643_3d809b1a: 'Single Select',
    auto_644_48a91d08: 'Multi Select',
    auto_687_479f10d7: 'Start Learning',
    auto_703_44431f13: 'Tax Amount',
    auto_707_8c582976: 'Outstanding credit order performance',
    auto_708_3447fc64: 'Subtotal',
    auto_2_7eac2f18: 'Shanghai',
    auto_3_d02b13ac: 'Putuo District',
    auto_64_794b0be6: 'A work order is created when customer support cannot resolve your issue directly',
    auto_82_f114b59f: 'Cross-entity Instructor request details',
    auto_92_1364e0d6: 'Approved',
    auto_96_0d7118c4: 'This month’s usage is within the limit',
    auto_97_daafa233: 'Your cross-entity device student has been updated',
    auto_136_ae72634b: 'Style 1',
    auto_137_72ab3cd3: 'Style 2',
    auto_164_f34f97e7: 'Bottom left',
    auto_165_57d50e6d: 'Top right',
    auto_188_6a461e5c: 'Scan with Alipay',
    auto_199_08498f60: '3D mode',
    auto_242_bcb964f8: 'Parent Master Franchisee',
    auto_278_3c291386: 'If the student only has one Instructor, removing it will change the status to no Instructor assigned',
    auto_578_fe32b009: 'Continue Publishing',
    auto_624_a921024f: 'WeChat added',
    auto_625_6dbd04d4: 'Visit scheduled',
    auto_626_c3cdab96: 'Visited',
    auto_627_2c036380: 'Invalid',
    auto_1724_16ad7868: 'To ensure uninterrupted outbound calling, your plan will automatically renew based on the selected subscription duration',
    auto_23_c7c89db7: 'Service activation and onboarding will be completed within the specified timeframe. In some regions, activation may take longer due to limited number resources',
    auto_111_81f9bfcc: 'Supports JPG, PNG, GIF formats (RGB mode, max size 5MB)',
    auto_150_4c7871e5: 'Shipping is paid upon delivery. The actual cost may vary by up to 20%, depending on the carrier',
    auto_153_c2ab8b22: 'Prepaid shipping is optional. If not selected, shipping fees must be paid to the carrier upon delivery',
    auto_154_426cde05: 'If prepaid shipping is applied and the order later qualifies for free shipping, the prepaid amount will be refunded',
    auto_264_96fec72b: 'Maximum of 5 items',
    auto_266_ec12174c: 'Note: Accounts set as "Emergency Contacts" will receive notifications from headquarters via phone and message in extremely rare cases (generally no more than 3 times per month). Please remind the designated personnel to answer their phones.',
    auto_577_09100b8f: 'Sensitive word detection',
    auto_651_fce225af: 'Active',
  },
  serviceCenter: {
    coinMall: 'Rewards Store',
    pickupStore: 'Pickup Store',
    providePickupExchange: 'Enable product redemption in the Pickup Store',
    pickupExchangeDesc: 'Once enabled, students can place orders and redeem products in the Pickup Store',
    pickupStoreDisplaySetting: 'Pickup Store Display Settings',
    productName: 'Product Name',
    enterProductName: 'Enter Product Name',
    displaySwitchDesc: 'Display toggle (when enabled, the product will be visible in the Pickup Store)',
    productImage: 'Product Image',
    exchangePrice: 'Redemption Price',
    operation: 'Actions',
    enableSuccess: 'Enabled successfully',
    disableSuccess: 'Disabled successfully'
  },
  asEditor: {
    backActivityList: 'Back to Campaign List',
    stepTitleBasicInfo: 'Campaign Details',
    stepTitleMarketingMaterial: 'Marketing Assets Upload',
    stepTitleReview: 'Page Preview & Review',
    auto_1_59cf5f64: 'View Instructions',
    auto_1_8c920303: 'Page Title',
    auto_2_5371635d: 'Reset',
    auto_5_02873c22: 'Squirrel Ai Limited-Time Campaign',
    auto_6_bb452d56: 'View',
    auto_7_afc01000: 'Use Template',
    auto_8_7905777d: 'Preview Changes',
    auto_8_7ec6ee4e: 'After resetting, all added or modified content will be lost',
    auto_9_cf70301c: 'Preview',
    auto_10_3a85785f: 'View JSON',
    auto_10_9ae5ae83: 'Confirm',
    auto_11_a9ede7c9: 'Cancel',
    auto_11_c18162c3: 'Import JSON',
    auto_12_1db9bee1: 'Export JSON',
    auto_12_7f63d57a: 'Image Banner',
    auto_13_03ee8a72: 'Save',
    auto_14_33ef2ff7: 'Unsaved changes will be lost when returning to the list',
    auto_14_febf0bcd: 'iPhone 8 Screen Height',
    auto_15_6200fa9c: 'Page Settings',
    auto_15_a2fa015c: 'Notice',
    auto_16_3a051693: 'Component Manager',
    auto_17_0b3be60c: 'Component Settings',
    auto_18_50ea7734: 'Text content cannot be empty',
    auto_18_e1e54ae8: 'Use different campaign names for better tracking across locations or initiatives',
    auto_19_75e96370: 'Start Date',
    auto_19_dc443ba0: 'No time limit',
    auto_20_d3ef25f3: 'End Date',
    auto_20_d74687a5: 'Set time range',
    auto_21_37deb38e: 'Campaign Title',
    auto_21_b741d0eb: 'Display style when shared on WeChat',
    auto_22_17d82179: 'Next',
    auto_22_9ec9bd6b: 'Campaign Description',
    auto_23_46ad2b24: 'Campaign Name',
    auto_23_90f5e9d6: 'Enter campaign details',
    auto_24_ddb80bb3: 'Upload marketing assets',
    auto_24_f07cb5f2: 'Enter campaign name',
    auto_25_5e199f9c: 'Campaign Duration',
    auto_25_fc33d4e0: 'Review campaign page before publishing',
    auto_27_f0e1a8e1: 'Enter campaign title',
    auto_29_658293df: 'Enter campaign description',
    auto_30_3f85201e: 'Back',
    auto_31_5ba29762: 'Publish',
  },
  channelAgents: {
    auto_1_50f0c2f6: 'Lead Status',
    auto_1_bcc4eca0: 'Upgrade Application',
    auto_2_57e34a20: 'First Contract Reward Rate',
    auto_3_1cd11945: 'Franchisee Renewal Referral Reward Rate',
    auto_3_b8640dd0: 'Review Time',
    auto_4_a361b8d8: 'Referrer',
    auto_5_8edf6c66: 'Referring Master Franchisee Name',
    auto_5_e3ef133a: 'Upgrade To',
    auto_6_c5d37c9b: 'Referrer Region',
    auto_6_d48837f6: 'Select',
    auto_7_6370bfd0: 'Referrer',
    auto_7_b3e1df51: 'Required Upgrade Quota',
    auto_8_58f6b177: 'Current Level',
    auto_8_c4154868: 'Referrer Phone',
    auto_9_31823765: 'Available Quota',
    auto_9_ff87ff59: 'Customer Communication Screenshot',
    auto_10_aec53ef9: 'Notes',
    auto_10_af593915: 'Reward Type',
    auto_11_5f0a4c24: 'Current Channel Partner Level',
    auto_11_d4e95212: 'Payout Master Franchisee',
    auto_12_216edddb: 'Status',
    auto_12_26977aef: 'Payout Master Franchisee Name',
    auto_13_5a9f7023: 'Submitting Master Franchisee',
    auto_13_9842aea2: 'Level A',
    auto_14_d4a62bd1: 'Submitting Master Franchisee Name',
    auto_14_f7a21f63: 'Level B',
    auto_15_c80f893e: 'Submitting Region',
    auto_16_9c37a83e: 'Customer Name',
    auto_17_6fd3cb0e: 'Customer Phone',
    auto_18_9bafa9cb: 'Customer Region',
    auto_19_71922b9a: 'Customer Background',
    auto_20_3d186f73: 'Sales Representative Name',
    auto_21_94808661: 'Sales Communication Screenshot',
    auto_23_36a06e97: 'Associated Channel Partner',
    auto_24_cedc8cdd: 'Associated Channel Partner Name',
    auto_26_7ecf0773: 'Cycle',
    auto_28_db1ffdb8: 'Shareholder Name',
    auto_29_a20083fa: 'Investment Amount ($10K)',
    auto_30_a849f541: 'Referral Reward',
    auto_31_c83c19fa: 'Squirrel Ai',
    auto_32_7cfa5436: 'Squirrel Points',
    auto_33_f962ea2f: 'Rebate Adjustment',
    auto_34_5aacbc1f: 'First-time',
    auto_35_55d06364: 'Reward Category',
    auto_36_5aacf3db: 'Click Confirm to submit the application',
    channelAgentId: 'Channel Partner ID',
    cumulativeChannelAgentLevel: 'Cumulative Channel Partner Level',
    effectiveCycle: 'Effective Period',
    applyTime: 'Application Time',
    applicant: 'Applicant',
    auditOpinion: 'Review Comments',
    creator: 'Created By',
    createTime: 'Created Time',
    equityInfo: 'Equity Information',
    agent: 'Master Franchisee',
    shareholderName: 'Shareholder Name',
    investAmountWanYuan: 'Investment Amount ($10K)',
    relatedChannelAgent: 'Associated Channel Partner',
    relatedChannelAgentName: 'Associated Channel Partner Name',
    changeLog: 'Change Log',
    pleaseSelectStatus: 'Select Status',
    applyStatusPendingReview: 'Pending Review',
    applyStatusToBeSigned: 'Pending Signature',
    applyStatusInEffect: 'Active',
    applyStatusExpired: 'Expired',
    applyStatusReturned: 'Rejected',
    applyStatusCancelled: 'Cancelled',
    firstContractRewardRatio18: 'First Contract Reward Rate',
    levelA13: 'Level A',
    levelB14: 'Level B',
    levelC15: 'Level C',
    levelD16: 'Level D',
    perfCustomerAccountOpenTime: 'Customer Account Activation Time',
    perfAccountOpenTime: 'Account Activation Time',
    perfSource: 'Performance Source',
    perfPleaseSelectRewardType: 'Select Reward Type',
    perfPleaseSelectSource: 'Select Performance Source',
    perfContractLastPayTime: 'Last Contract Payment Time',
    perfContractSignAmount: 'Contract Value',
    perfContractPaidAmountCol: 'Paid Contract Amount',
    perfUsedQuota: 'Used Quota',
    perfAvailableQuota: 'Available Quota',
    perfIntroducerId: 'Referrer ID',
    perfIntroducerName: 'Referrer Name',
    perfWithdrawableAmount: 'Withdrawable Amount',
    perfPayoutAgentId: 'Payout Master Franchisee ID',
    perfEffectiveAvailableTotal: 'Total Effective Available Quota: {amount}',
    quotaUseType: 'Usage Type',
    quotaUseLevel: 'Upgrade To',
    quotaUseAmount: 'Quota Used',
    quotaUseUser: 'User',
    quotaUseTime: 'Usage Time',
    quotaUseIntroducerId: 'Referrer ID',
    quotaUseIntroducerName: 'Referring Master Franchisee Name',
    quotaUseDealerUpgrade: 'Franchisee Upgrade',
    quotaUseAgentDiscount: 'Master Franchisee Discount',
    quotaUsePleaseSelectType: 'Select Type',
    regionCurrentChannelAgentLevel: 'Current Channel Partner Level',
    regionPleaseSelectReferralCustomerId: 'Select Referral Customer ID',
    regionPleaseSelectLevel: 'Select Level',
    regionOrderAmount: 'Total Order Amount',
    afpReferralCustomerId: 'Referral Customer ID',
    afpReferralCustomerName: 'Referral Customer Name',
    afpReferralContractAmount: 'Referral Contract Value',
    afpPurchaseOrderNo: 'Purchase Order No.',
    afpPaymentStatus: 'Payment Status',
    afpOrderStatus: 'Order Status',
    afpProductName: 'Product Name',
    afpPurchaseQuantity: 'Purchase Quantity',
    afpDeliveryQuantity: 'Shipped Quantity',
    afpPurchaseUnitPrice: 'Unit Price',
    afpPurchaseTotalAmount: 'Total Purchase Amount',
    afpContractPaidAmount: 'Contract Paid Amount',
    afpCumulativeReturnedAmount: 'Cumulative Rebate Amount',
    afpDeliveryTime: 'Delivery Time',
    afpRewardRate: 'Reward Rate',
    afpRewardAmount: 'Reward Amount',
    afpIsFirstTime: 'First-time',
    afpSettlementYearMonth: 'Settlement Period',
    afpIntroducerOrChannelAgentId: 'Referrer / Channel Partner ID',
    afpChannelAgentName: 'Channel Partner Name',
    afpRegionalAgentId: 'Regional Master Franchisee ID',
    afpRegionalAgentShareAmount: 'Regional Share Amount',
    crfRenewOrderPaymentAmount: 'Renewal Payment Amount',
    crfSubscriptionFeeAmount: 'Subscription Fee',
    crfRewardCoefficient: 'Reward Multiplier',
    crfRewardGranted: 'Reward Issued',
    crfSubscriptionFeeRebate: 'Subscription Rebate',
    crfValueAddedServiceFee: 'Value-added Service Fee',
    crfCumulativeChannelLevel: 'Cumulative Channel Level',
  },
  inAndOut: {
    auto_1_139fd654: 'Warning: Data Errors Detected',
    auto_1_b9dc19e5: 'Related Order',
    auto_2_2fd6123c: 'Some data contains errors. Do you want to proceed with the import?',
    auto_10_91f7dd37: 'Cloud Warehouse Outbound Order No.',
    auto_11_cd5e206e: 'Shipping Address',
    auto_12_7776b108: 'Notes',
    auto_14_b13e13c2: 'Pickup Order No.',
    auto_15_304026c0: 'Master Franchisee Name',
    auto_16_d949d795: 'Created By',
    auto_17_9577c244: 'Warehouse',
    auto_18_5459cfcc: 'Recipient Name',
    auto_19_f69fde8a: 'Recipient Phone',
    auto_20_6f03a2c9: 'State / City / ZIP Code',
    auto_21_df0b5b51: 'Shipment Status',
    auto_25_92958a8d: 'Inventory Transfer Order No.',
    auto_28_9f7eb351: 'Shipping Warehouse',
    auto_30_10d00f1b: 'JD Adjustment Order No.',
    auto_31_3077cfda: 'Receiving Warehouse',
    auto_33_be3c245c: 'Transfer Order No.',
    auto_34_6e471e75: 'Order Status',
    auto_35_fe4361fd: 'Submitted Time',
    auto_36_4c3cba93: 'Cloud Warehouse Transfer Order No.',
    auto_39_a8a196d5: 'Related Transfer Order No.',
    auto_41_f052cebf: 'Download Import Template',
    auto_42_1c0777fe: 'Import Details',
  },
  referral: {
    auto_1_17a24c7c: 'Are you sure you want to delete this image?',
    auto_1_35aee83a: 'Scan with WeChat to preview',
    auto_2_05b0a2c5: 'Delete Image',
    auto_2_7cc4dc6c: 'Preview',
    auto_3_9d5473a6: 'Template Cover Image',
    auto_4_6bc3b01d: 'Template Background Image',
    auto_5_037ad60c: 'Are you sure you want to publish this image?',
    auto_6_00c325b5: 'Publish Image',
    auto_9_be2c267b: 'Are you sure you want to unpublish this image?',
    auto_10_6945e73a: 'Unpublish Image',
    auto_11_79b14662: 'Confirm',
    auto_12_b6180373: 'Cancel',
    auto_13_5eb2aadb: 'Preview Image',
    auto_14_7160357c: 'Delete Image',
    auto_17_14df2a60: 'Select',
  },
  noviceTasks: {
    auto_1_334e5e27: 'Please use your Squirrel Ai account linked with DingTalk to scan and register',
    auto_1_38604ac9: 'Locked',
    auto_2_541d9670: 'Confirm',
    auto_2_cc866735: 'Go to Purchase',
    auto_3_1f99f135: 'Please scroll to the bottom of the page and spend at least 10 seconds reviewing the content',
    auto_3_50099175: 'Set Up Now',
    auto_4_820c4504: 'Please scan the QR code with WeChat to add the Squirrel Ai HQ account',
    auto_4_861380f9: 'Got it',
    auto_5_76791bc2: 'Cloud Learning access has been granted',
    auto_5_8ae23169: 'Help Center',
    auto_6_6d258c8a: 'Register',
    auto_6_c9482bb1: 'Notice',
    auto_7_4f1f7097: 'Add Squirrel Ai HQ WeChat Account',
  },
  pineconeBusiness: {
    auto_1_144af95b: 'Cancel',
    auto_2_3f59f53b: 'Submit',
    auto_3_43d3c963: 'Activate Trial Account',
    auto_4_8f9f1606: 'Franchisee',
    auto_5_c037cf10: 'Target State',
    auto_6_c8b7bdd1: 'Student Phone Number',
    auto_7_d69a6971: 'Enter student phone number',
    auto_8_4240a3a7: 'Student Name',
    auto_9_56564323: 'Enter student name',
    auto_10_a0d4449d: 'Grade Level',
    auto_11_593fdd20: 'Select grade level',
    auto_12_0d9ebca8: 'Trial Date',
    auto_13_92aec48d: 'Select trial date',
  },
  systemManage: {
    auto_1_ea5a1f41: 'Extension / Agent ID',
    auto_2_6eaed7f7: 'Enter extension number',
    auto_3_f5a4a6b9: 'Enter agent ID',
    auto_4_889e956a: 'Caller ID',
    auto_5_74b44b16: 'Enter caller ID',
  },
  loadingRedirect: 'Loading…',
}
